import Helper from '../helper'
import Context from 'skypager-registry/lib/context'
import isFunction from 'lodash/pick'

export class Feature extends Helper {
  static isCacheable = true

  static dirname = __dirname

  static createRegistry(...args) {
    const reg = new Context('features', {
      context: require.context('../features', false, /\.js$/)  
    })

    reg.enabled = {}

    return reg
  }

	static attach(project, options = {}) {
		return Helper.attach(project, Feature, {
			registryProp: 'features',
			lookupProp: 'feature',
      cacheHelper: true,
      isCacheable: true,
			registry: options.registry || Feature.createRegistry(),
      ...options
		})
	}

  initialize() {
    this.applyInterface(this.featureMixin, {
      transformKeys: true,
      scope: this,
      partial: [this.context],
      insertOptions: true,
      right: true,
      hidden: false,
    })

  }

  enable(cfg) {
    if (this.isSupported) {
      this.host.applyInterface(this.hostMixin, {
        transformKeys: true,
        scope: this.host,
        partial: [this.host.context],
        insertOptions: true,
        right: true,
        hidden: false,
      })

      try {
        this.tryResult('featureWasEnabled', {}, this.options)
        
        if (this.host.featureWasEnabled) {
          this.host.featureWasEnabled.call(this.host, this, this.options)
        }
  
        if (cfg && isFunction(cfg)) {
          this.configureWith(cfg)
        }
      } catch(error) {

      }

      this.set(`host.features.enabled.${this.name}`, this.id)
      
      return this
    }  else {
      throw new Error('This feature is not supported')
    } 

    return this
  }

  runMethod(methodName, ...args) {
    const method = this.tryGet(methodName, this.get(methodName))
    return isFunction(method) && method.call(this, ...args.push(this.context))
  }

  get hostMixin() {
    return this.projectMixin
  }

  get projectMixin() {
     return this.chain
      .get('hostMethods')
      .filter(m => isFunction(this.tryGet(m)))
      .keyBy(m => m)
      .mapValues(m => this.tryGet(m))
      .pickBy(v => isFunction(v))
      .value()
  }

  get featureMixin() {
    const hostMethods = this.hostMethods

     return this.chain
      .get('featureMethods')
      .filter(m => hostMethods.indexOf(m) === -1 && isFunction(this.tryGet(m)))
      .keyBy(m => m)
      .mapValues(m => this.tryGet(m))
      .pickBy(v => isFunction(v))
      .value()
  }

  get featureMethods() {
    return this.tryResult('featureMethods', [])
  }

  get hostMethods() {
    return this.tryResult('projectMethods', this.tryResult('hostMethods', []))
  }

  get projectMethods() {
    return this.tryResult('projectMethods', this.tryResult('hostMethods', []))
  }

  get dependencies() {
    return this.tryGet('dependencies', {})
  }

  get isSupported() {
    return this.tryResult('isSupported', true)
  }
}

export default Feature

export const isCacheable = true

export const attach = Feature.attach


// WEBPACK FOOTER //
// ./src/helpers/feature.js